
import { format } from 'date-fns';
import { ChartDataPoint } from './chartDataUtils';

export function formatXAxisTick(value: string, isMobile: boolean, chartData: ChartDataPoint[]): string {
  if (isMobile) {
    // For mobile, simplify the date format to save space
    const day = chartData.find(d => d.date === value);
    return day ? format(day.absoluteDate, 'd') : value;
  }
  // For desktop, use the full date format
  return value;
}

export function formatTooltipLabel(label: string, chartData: ChartDataPoint[]): string {
  const day = chartData.find(d => d.date === label || format(d.absoluteDate, 'd') === label);
  return day 
    ? `Day ${day.day}: ${format(day.absoluteDate, 'MMM d')} (${day.phase.charAt(0).toUpperCase() + day.phase.slice(1)} Phase)` 
    : label;
}
